import React, { useContext, useEffect } from "react";
import dayjs from "dayjs";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useLazyQuery } from "@apollo/client";
// import { ListFinancialYearVars } from "../../../../Accounts/hooks/useActiveFinancialYear";
// import { FinyearByInstId } from "../../../../../queries/institution/financialyear/list/byid";
// import { ListFinancialYearData } from "../../../../../Types/Accounting";
import Pointer from "../../../../images/Pointer.svg";
import useAssetTableJson from "../../../../json/useAssetTableJson";

// import { AppContext } from "../../../../context/context";
import { Title } from "../../../../stories/Title/Title";
// import { TableHeaderJsonProps } from "../../../../utils/types";
import useUrlParams from "../../../../customHooks/useUrlParams";
import { GetFinYrsResult, GetFinYrsVars } from "./queries/types";
import { GetFinYrs } from "./queries/queries";
import { Button } from "../../../../stories/Button/Button";
import LoadingModal from "../../../pages/LoadingModal";
import { AppContext } from "../../../../context/context";
interface Props {
  onlyTable: boolean;
  setActiveFinancialyearopenmodal?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}
const FinancialYearList = ({
  onlyTable,
  setActiveFinancialyearopenmodal
}: Props) => {
  const { Masters_Table } = useAssetTableJson();

  const {state} = useContext(AppContext)

  const { customer_id } = useUrlParams();

  const [
    GetFinancialYears,
    { data: FinancialYearResponse, loading: GetFinYrsLoading }
  ] = useLazyQuery<GetFinYrsResult, GetFinYrsVars>(GetFinYrs, {
    fetchPolicy: "network-only"
  });
  const financialYearList = FinancialYearResponse
    ? FinancialYearResponse.GetFinYrs
    : [];

  useEffect(() => {
    if (customer_id || state.customerId) {
      GetFinancialYears({
        variables: { customerID: customer_id ? customer_id : state.customerId, companyID: 0 }
      });
    }
  }, [customer_id,state.customerId, GetFinancialYears]);

  return (
    <div className="col  fin-yr__datablock--right-frame">
      <Title variant="subtitle1">
        {onlyTable ? "Financial Year List" : "Make Financial Year Active"}
      </Title>
      <div className="fin-yr__datablock--tableblock">
        <TableContainer className="fin-yr__datablock--table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {Masters_Table.FinancialYear.map((th, index: React.Key) => {
                  return (
                    <React.Fragment key={index}>
                      <TableCell className={th.className}>
                        {th.labelName}
                      </TableCell>
                    </React.Fragment>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {financialYearList.map((response, index: number) => (
                <React.Fragment key={index}>
                  <TableRow
                    className={
                      response.finIsCurrYr ? "activefinancialyear" : ""
                    }
                  >
                    <TableCell
                      id="td-center"
                      className="institution__table--slno"
                    >
                      {response.finIsCurrYr && (
                        <img
                          className="activefinancialyearIcon"
                          src={Pointer}
                          alt="/"
                        />
                      )}
                      {index + 1}
                    </TableCell>
                    <TableCell
                      id="td-center"
                      className="institution__table--year"
                    >
                      {response.finYr}
                    </TableCell>

                    <TableCell
                      id="td-center"
                      className="institution__table--date"
                    >
                      {dayjs(response.finStDate).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell
                      id="td-center"
                      className="institution__table--date"
                    >
                      {dayjs(response.finEndDate).format("DD-MM-YYYY")}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {financialYearList.length > 0 && onlyTable === false ? (
        <Button
          mode="active"
          type="button"
          onClick={() => setActiveFinancialyearopenmodal?.(true)}
        >
          Make Financial Year Active
        </Button>
      ) : null}
      <LoadingModal flag={GetFinYrsLoading} />
    </div>
  );
};

export default FinancialYearList;
